import React from 'react'
import { useSelector } from 'react-redux'

import { Icon, TableV2 } from 'src/components'

import { selectCardProviders } from 'src/selectors/cardProvider.selector'
import { CardProviderName, ICardProviderActions } from 'src/enums/CardProviderEnum'
import { faListOl, faTrash } from '@fortawesome/free-solid-svg-icons'
import { isAllowed } from 'src/selectors/modules.selector'
import { cardProviderPermissions } from 'src/enums/permissions'
import { loadingSelector } from 'src/selectors/loading.selector'
import { actions } from 'src/actions/cardProvider.actions'

interface CardProviderListProps {
  onSelect: (provider: ICardProvider, action: ICardProviderActions) => void
  loadingDelete: boolean
}

export const CardProviderList = ({ onSelect, loadingDelete }: CardProviderListProps) => {
  const providers = useSelector(selectCardProviders)

  const canViewDevices = useSelector(state =>
    isAllowed(state, [cardProviderPermissions.viewDevices]),
  )

  const loading = useSelector(state =>
    loadingSelector([actions.GET_CARD_PROVIDERS])(state),
  )

  const canDelete = useSelector(state =>
    isAllowed(state, [cardProviderPermissions.delete]),
  )

  const renderActions = (provider: ICardProvider) => {
    return (
      <div className={'center'}>
        {canViewDevices && provider.state === 'Aprobado' && (
          <Icon
            icon={faListOl}
            tooltip={'Listado de dispositivos'}
            onClick={() => onSelect(provider, ICardProviderActions.GET_CARD_DEVICES)}
            className={'mr-2'}
            loading={loadingDelete}
          />
        )}

        {canDelete && (
          <Icon
            icon={faTrash}
            tooltip={'Eliminar'}
            onClick={() =>
              onSelect(provider, ICardProviderActions.DELETE_CARD_CONNECTION)
            }
            className={'mr-2'}
            loading={loadingDelete}
          />
        )}
      </div>
    )
  }

  const headers: ITableHeader[] = [
    {
      show: true,
      label: 'Proveedor',
      type: 'custom',
      value: [],
      custom: provider => CardProviderName[provider.id],
    },
    {
      show: true,
      label: 'Estado',
      type: 'text',
      value: ['state'],
    },
    {
      show: true,
      label: 'Configurado por',
      type: 'text',
      value: ['createdBy'],
    },
    {
      show: true,
      label: 'Fecha de configuración',
      type: 'date',
      value: ['createdAt'],
    },
    {
      show: canDelete || canViewDevices,
      label: 'Acciones',
      type: 'custom',
      className: 'mini',
      value: [],
      custom: provider => renderActions(provider),
    },
  ]

  return (
    <TableV2
      // @ts-ignore
      loading={loading}
      items={providers}
      headers={headers}
    />
  )
}
